angular.module('app').component('customizedInfographicsComponent', {
    templateUrl: 'app/components/customized-infographics/customized-infographics.tmpl.html'
  });
